import { Component, OnInit, ViewChild, ElementRef } from "@angular/core"
import { KapraoService } from "../../../services/kaprao.service"
import { MessageService } from "../../../services/login.service"
import { ActivatedRoute } from "@angular/router"
import { TranslateService, LangChangeEvent } from "@ngx-translate/core"

@Component({
    selector: "app-print-purchase",
    templateUrl: "./print-purchase.component.html",
    styleUrls: ["./print-purchase.component.scss"],
})
export class PrintPurchaseComponent implements OnInit {
    pData
    subscription
    printData
    selectedLang
    pNumber
    @ViewChild("mainContentArea") elementView: ElementRef
    constructor(
        private elRef: ElementRef,
        private service: KapraoService,
        private messageService: MessageService,
        private route: ActivatedRoute,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        // console.log(this.elRef.nativeElement.parentNode.offsetHeight);
        this.selectedLang = this.translate.currentLang
        this.translate.onLangChange.subscribe(
            (langChangeEvent: LangChangeEvent) => {
                this.selectedLang = langChangeEvent.lang
            }
        )
        this.pData = JSON.parse(this.route.snapshot.paramMap.get("printData"))
        if (this.pData.status == "RECEIVED") {
            this.pData.list.forEach((e) => {
                console.log(e)
                e.totalR = e.actualQuantity * e.actualPricePerUnit
            })
        } else {
            this.pData.list.forEach((e) => {
                console.log(e)
                e.totalR = e.quantity * e.pricePerUnit
            })
        }
        console.log(this.pData)
        //     this.pData.list = [
        //         {
        //             "mpID": "62d517230a8f55b9f9623716",
        //             "mpName": {
        //                 "th": "ไข่ไก่",
        //                 "en": "Eggs"
        //             },
        //             "pricePerUnit": 119,
        //             "quantity": 42,
        //             "actualQuantity": 0,
        //             "total": 4998,
        //             "unitName": {
        //                 "th": "แผง",
        //                 "en": "Packs"
        //             },
        //             "marketPrice": 119
        //         },
        //         {
        //             "mpID": "64a2d58be00beb5354406bf0",
        //             "mpName": {
        //                 "th": "หมูสับเกรด B",
        //                 "en": "Minced Pork Grade B"
        //             },
        //             "pricePerUnit": 90,
        //             "quantity": 67,
        //             "actualQuantity": 0,
        //             "total": 6030,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 90
        //         },
        //         {
        //             "mpID": "62e61df810e6326c7655fd87",
        //             "mpName": {
        //                 "th": "ข้าว",
        //                 "en": "Rice"
        //             },
        //             "pricePerUnit": 60,
        //             "quantity": 32,
        //             "actualQuantity": 0,
        //             "total": 1920,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 60
        //         },
        //         {
        //             "mpID": "62a7627eea9093d47416872d",
        //             "mpName": {
        //                 "th": "พริกขี้หนู",
        //                 "en": "พริกขี้หนู"
        //             },
        //             "pricePerUnit": 30.5,
        //             "quantity": 78,
        //             "actualQuantity": 0,
        //             "total": 2379,
        //             "unitName": {
        //                 "th": "กรัม",
        //                 "en": "Gram"
        //             },
        //             "marketPrice": 30.5
        //         },
        //         {
        //             "mpID": "6290b30b993dbf3040425b18",
        //             "mpName": {
        //                 "th": "ใบกระเพรา",
        //                 "en": "Holy basil"
        //             },
        //             "pricePerUnit": 20.5,
        //             "quantity": 6,
        //             "actualQuantity": 0,
        //             "total": 123,
        //             "unitName": {
        //                 "th": "กรัม",
        //                 "en": "Gram"
        //             },
        //             "marketPrice": 20.5
        //         },
        //         {
        //             "mpID": "64a2d567e00beb5354406bef",
        //             "mpName": {
        //                 "th": "หมูสับเกรด A",
        //                 "en": "Minced Pork Grade A"
        //             },
        //             "pricePerUnit": 100,
        //             "quantity": 34,
        //             "actualQuantity": 0,
        //             "total": 3400,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 100
        //         },
        //         {
        //             "mpID": "62e4c33a10e6326c7655fd73",
        //             "mpName": {
        //                 "th": "กุนเชียง",
        //                 "en": "Sausage"
        //             },
        //             "pricePerUnit": 150,
        //             "quantity": 4,
        //             "actualQuantity": 0,
        //             "total": 600,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 150
        //         },
        //         {
        //             "mpID": "652aae62c8e9d1410797917a",
        //             "mpName": {
        //                 "th": "มิตรผล น้ำตาลทรายขาวบริสุทธิ์ 1 กิโลกรัม x 5 ถุง",
        //                 "en": "มิตรผล น้ำตาลทรายขาวบริสุทธิ์ 1 กิโลกรัม x 5 ถุง"
        //             },
        //             "pricePerUnit": 66,
        //             "quantity": 56,
        //             "actualQuantity": 0,
        //             "total": 3696,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 66
        //         },
        //         {
        //             "mpID": "6467439211cdf98601eff940",
        //             "mpName": {
        //                 "th": "พริกสวนเด็ด",
        //                 "en": " chili garden"
        //             },
        //             "pricePerUnit": 260,
        //             "quantity": 5,
        //             "actualQuantity": 0,
        //             "total": 1300,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 260
        //         },
        //         {
        //             "mpID": "6467440511cdf98601eff942",
        //             "mpName": {
        //                 "th": "ตะใคร้",
        //                 "en": " lemon grass"
        //             },
        //             "pricePerUnit": 40,
        //             "quantity": 6,
        //             "actualQuantity": 0,
        //             "total": 240,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 40
        //         },
        //         {
        //             "mpID": "62946cc61995110e56339b62",
        //             "mpName": {
        //                 "th": "สะโพกไก่",
        //                 "en": "Chicken thighs"
        //             },
        //             "pricePerUnit": 80,
        //             "quantity": 8,
        //             "actualQuantity": 0,
        //             "total": 640,
        //             "unitName": {
        //                 "th": "กรัม",
        //                 "en": "Gram"
        //             },
        //             "marketPrice": 80
        //         },
        //         {
        //             "mpID": "6467431a11cdf98601eff93d",
        //             "mpName": {
        //                 "th": "กระเพราแดง",
        //                 "en": " red basil"
        //             },
        //             "pricePerUnit": 60,
        //             "quantity": 10,
        //             "actualQuantity": 0,
        //             "total": 600,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 60
        //         },
        //         {
        //             "mpID": "645b6561da746eaf0803b473",
        //             "mpName": {
        //                 "th": "ไข่เป็ด",
        //                 "en": "Duck Egg"
        //             },
        //             "pricePerUnit": 120,
        //             "quantity": 32,
        //             "actualQuantity": 0,
        //             "total": 3840,
        //             "unitName": {
        //                 "th": "แผง",
        //                 "en": "Packs"
        //             },
        //             "marketPrice": 120
        //         },
        //         {
        //             "mpID": "63357b842b6fbde812f8a9ee",
        //             "mpName": {
        //                 "th": "เนื้อ",
        //                 "en": "Meat"
        //             },
        //             "pricePerUnit": 130,
        //             "quantity": 8,
        //             "actualQuantity": 0,
        //             "total": 1040,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 130
        //         },
        //         {
        //             "mpID": "64a2d4bfe00beb5354406bed",
        //             "mpName": {
        //                 "th": "หมูสันคอ",
        //                 "en": "Pork Neck"
        //             },
        //             "pricePerUnit": 128,
        //             "quantity": 23,
        //             "actualQuantity": 0,
        //             "total": 2944,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 128
        //         },
        //         {
        //             "mpID": "646744b511cdf98601eff946",
        //             "mpName": {
        //                 "th": "บล็อกโคลี่",
        //                 "en": "broccoli"
        //             },
        //             "pricePerUnit": 70,
        //             "quantity": 36,
        //             "actualQuantity": 0,
        //             "total": 2520,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 70
        //         },
        //         {
        //             "mpID": "64a2d49de00beb5354406bec",
        //             "mpName": {
        //                 "th": "หมูสามชั้น",
        //                 "en": " Streaky Pork"
        //             },
        //             "pricePerUnit": 145,
        //             "quantity": 5,
        //             "actualQuantity": 0,
        //             "total": 725,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 145
        //         },
        //         {
        //             "mpID": "629b1d3ec3a19dcff457c3d4",
        //             "mpName": {
        //                 "th": "เหล้าจีน",
        //                 "en": "Chinese liquor"
        //             },
        //             "pricePerUnit": 145,
        //             "quantity": 21,
        //             "actualQuantity": 0,
        //             "total": 3045,
        //             "unitName": {
        //                 "th": "กรัม",
        //                 "en": "Gram"
        //             },
        //             "marketPrice": 145
        //         },
        //         {
        //             "mpID": "64a2d51de00beb5354406bee",
        //             "mpName": {
        //                 "th": "มันหมู",
        //                 "en": "Lard"
        //             },
        //             "pricePerUnit": 30,
        //             "quantity": 8,
        //             "actualQuantity": 0,
        //             "total": 240,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 30
        //         },
        //       {
        //           "mpID": "62d517230a8f55b9f9623716",
        //           "mpName": {
        //               "th": "ไข่ไก่",
        //               "en": "Eggs"
        //           },
        //           "pricePerUnit": 119,
        //           "quantity": 42,
        //           "actualQuantity": 0,
        //           "total": 4998,
        //           "unitName": {
        //               "th": "แผง",
        //               "en": "Packs"
        //           },
        //           "marketPrice": 119
        //       },
        //       {
        //           "mpID": "64a2d58be00beb5354406bf0",
        //           "mpName": {
        //               "th": "หมูสับเกรด B",
        //               "en": "Minced Pork Grade B"
        //           },
        //           "pricePerUnit": 90,
        //           "quantity": 67,
        //           "actualQuantity": 0,
        //           "total": 6030,
        //           "unitName": {
        //               "th": "กิโลกรัม",
        //               "en": "Kg."
        //           },
        //           "marketPrice": 90
        //       },
        //       {
        //           "mpID": "62e61df810e6326c7655fd87",
        //           "mpName": {
        //               "th": "ข้าว",
        //               "en": "Rice"
        //           },
        //           "pricePerUnit": 60,
        //           "quantity": 32,
        //           "actualQuantity": 0,
        //           "total": 1920,
        //           "unitName": {
        //               "th": "กิโลกรัม",
        //               "en": "Kg."
        //           },
        //           "marketPrice": 60
        //       },
        //       {
        //           "mpID": "62a7627eea9093d47416872d",
        //           "mpName": {
        //               "th": "พริกขี้หนู",
        //               "en": "พริกขี้หนู"
        //           },
        //           "pricePerUnit": 30.5,
        //           "quantity": 78,
        //           "actualQuantity": 0,
        //           "total": 2379,
        //           "unitName": {
        //               "th": "กรัม",
        //               "en": "Gram"
        //           },
        //           "marketPrice": 30.5
        //       },
        //       {
        //           "mpID": "6290b30b993dbf3040425b18",
        //           "mpName": {
        //               "th": "ใบกระเพรา",
        //               "en": "Holy basil"
        //           },
        //           "pricePerUnit": 20.5,
        //           "quantity": 6,
        //           "actualQuantity": 0,
        //           "total": 123,
        //           "unitName": {
        //               "th": "กรัม",
        //               "en": "Gram"
        //           },
        //           "marketPrice": 20.5
        //       },
        //       {
        //           "mpID": "64a2d567e00beb5354406bef",
        //           "mpName": {
        //               "th": "หมูสับเกรด A",
        //               "en": "Minced Pork Grade A"
        //           },
        //           "pricePerUnit": 100,
        //           "quantity": 34,
        //           "actualQuantity": 0,
        //           "total": 3400,
        //           "unitName": {
        //               "th": "กิโลกรัม",
        //               "en": "Kg."
        //           },
        //           "marketPrice": 100
        //       },
        //       {
        //           "mpID": "62e4c33a10e6326c7655fd73",
        //           "mpName": {
        //               "th": "กุนเชียง",
        //               "en": "Sausage"
        //           },
        //           "pricePerUnit": 150,
        //           "quantity": 4,
        //           "actualQuantity": 0,
        //           "total": 600,
        //           "unitName": {
        //               "th": "กิโลกรัม",
        //               "en": "Kg."
        //           },
        //           "marketPrice": 150
        //       },
        //       {
        //           "mpID": "652aae62c8e9d1410797917a",
        //           "mpName": {
        //               "th": "มิตรผล น้ำตาลทรายขาวบริสุทธิ์ 1 กิโลกรัม x 5 ถุง",
        //               "en": "มิตรผล น้ำตาลทรายขาวบริสุทธิ์ 1 กิโลกรัม x 5 ถุง"
        //           },
        //           "pricePerUnit": 66,
        //           "quantity": 56,
        //           "actualQuantity": 0,
        //           "total": 3696,
        //           "unitName": {
        //               "th": "กิโลกรัม",
        //               "en": "Kg."
        //           },
        //           "marketPrice": 66
        //       },
        //       {
        //           "mpID": "6467439211cdf98601eff940",
        //           "mpName": {
        //               "th": "พริกสวนเด็ด",
        //               "en": " chili garden"
        //           },
        //           "pricePerUnit": 260,
        //           "quantity": 5,
        //           "actualQuantity": 0,
        //           "total": 1300,
        //           "unitName": {
        //               "th": "กิโลกรัม",
        //               "en": "Kg."
        //           },
        //           "marketPrice": 260
        //       },
        //       {
        //           "mpID": "6467440511cdf98601eff942",
        //           "mpName": {
        //               "th": "ตะใคร้",
        //               "en": " lemon grass"
        //           },
        //           "pricePerUnit": 40,
        //           "quantity": 6,
        //           "actualQuantity": 0,
        //           "total": 240,
        //           "unitName": {
        //               "th": "กิโลกรัม",
        //               "en": "Kg."
        //           },
        //           "marketPrice": 40
        //       },
        //       {
        //           "mpID": "62946cc61995110e56339b62",
        //           "mpName": {
        //               "th": "สะโพกไก่",
        //               "en": "Chicken thighs"
        //           },
        //           "pricePerUnit": 80,
        //           "quantity": 8,
        //           "actualQuantity": 0,
        //           "total": 640,
        //           "unitName": {
        //               "th": "กรัม",
        //               "en": "Gram"
        //           },
        //           "marketPrice": 80
        //       },
        //       {
        //           "mpID": "6467431a11cdf98601eff93d",
        //           "mpName": {
        //               "th": "กระเพราแดง",
        //               "en": " red basil"
        //           },
        //           "pricePerUnit": 60,
        //           "quantity": 10,
        //           "actualQuantity": 0,
        //           "total": 600,
        //           "unitName": {
        //               "th": "กิโลกรัม",
        //               "en": "Kg."
        //           },
        //           "marketPrice": 60
        //       },
        //       {
        //           "mpID": "645b6561da746eaf0803b473",
        //           "mpName": {
        //               "th": "ไข่เป็ด",
        //               "en": "Duck Egg"
        //           },
        //           "pricePerUnit": 120,
        //           "quantity": 32,
        //           "actualQuantity": 0,
        //           "total": 3840,
        //           "unitName": {
        //               "th": "แผง",
        //               "en": "Packs"
        //           },
        //           "marketPrice": 120
        //       },
        //       {
        //           "mpID": "63357b842b6fbde812f8a9ee",
        //           "mpName": {
        //               "th": "เนื้อ",
        //               "en": "Meat"
        //           },
        //           "pricePerUnit": 130,
        //           "quantity": 8,
        //           "actualQuantity": 0,
        //           "total": 1040,
        //           "unitName": {
        //               "th": "กิโลกรัม",
        //               "en": "Kg."
        //           },
        //           "marketPrice": 130
        //       },
        //       {
        //           "mpID": "64a2d4bfe00beb5354406bed",
        //           "mpName": {
        //               "th": "หมูสันคอ",
        //               "en": "Pork Neck"
        //           },
        //           "pricePerUnit": 128,
        //           "quantity": 23,
        //           "actualQuantity": 0,
        //           "total": 2944,
        //           "unitName": {
        //               "th": "กิโลกรัม",
        //               "en": "Kg."
        //           },
        //           "marketPrice": 128
        //       },
        //       {
        //           "mpID": "646744b511cdf98601eff946",
        //           "mpName": {
        //               "th": "บล็อกโคลี่",
        //               "en": "broccoli"
        //           },
        //           "pricePerUnit": 70,
        //           "quantity": 36,
        //           "actualQuantity": 0,
        //           "total": 2520,
        //           "unitName": {
        //               "th": "กิโลกรัม",
        //               "en": "Kg."
        //           },
        //           "marketPrice": 70
        //       },
        //       {
        //           "mpID": "64a2d49de00beb5354406bec",
        //           "mpName": {
        //               "th": "หมูสามชั้น",
        //               "en": " Streaky Pork"
        //           },
        //           "pricePerUnit": 145,
        //           "quantity": 5,
        //           "actualQuantity": 0,
        //           "total": 725,
        //           "unitName": {
        //               "th": "กิโลกรัม",
        //               "en": "Kg."
        //           },
        //           "marketPrice": 145
        //       },
        //       {
        //           "mpID": "629b1d3ec3a19dcff457c3d4",
        //           "mpName": {
        //               "th": "เหล้าจีน",
        //               "en": "Chinese liquor"
        //           },
        //           "pricePerUnit": 145,
        //           "quantity": 21,
        //           "actualQuantity": 0,
        //           "total": 3045,
        //           "unitName": {
        //               "th": "กรัม",
        //               "en": "Gram"
        //           },
        //           "marketPrice": 145
        //       },
        //       {
        //           "mpID": "64a2d51de00beb5354406bee",
        //           "mpName": {
        //               "th": "มันหมู",
        //               "en": "Lard"
        //           },
        //           "pricePerUnit": 30,
        //           "quantity": 8,
        //           "actualQuantity": 0,
        //           "total": 240,
        //           "unitName": {
        //               "th": "กิโลกรัม",
        //               "en": "Kg."
        //           },
        //           "marketPrice": 30
        //       },
        //         {
        //             "mpID": "62d517230a8f55b9f9623716",
        //             "mpName": {
        //                 "th": "ไข่ไก่",
        //                 "en": "Eggs"
        //             },
        //             "pricePerUnit": 119,
        //             "quantity": 42,
        //             "actualQuantity": 0,
        //             "total": 4998,
        //             "unitName": {
        //                 "th": "แผง",
        //                 "en": "Packs"
        //             },
        //             "marketPrice": 119
        //         },
        //         {
        //             "mpID": "64a2d58be00beb5354406bf0",
        //             "mpName": {
        //                 "th": "หมูสับเกรด B",
        //                 "en": "Minced Pork Grade B"
        //             },
        //             "pricePerUnit": 90,
        //             "quantity": 67,
        //             "actualQuantity": 0,
        //             "total": 6030,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 90
        //         },
        //         {
        //             "mpID": "62e61df810e6326c7655fd87",
        //             "mpName": {
        //                 "th": "ข้าว",
        //                 "en": "Rice"
        //             },
        //             "pricePerUnit": 60,
        //             "quantity": 32,
        //             "actualQuantity": 0,
        //             "total": 1920,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 60
        //         },
        //         {
        //             "mpID": "62a7627eea9093d47416872d",
        //             "mpName": {
        //                 "th": "พริกขี้หนู",
        //                 "en": "พริกขี้หนู"
        //             },
        //             "pricePerUnit": 30.5,
        //             "quantity": 78,
        //             "actualQuantity": 0,
        //             "total": 2379,
        //             "unitName": {
        //                 "th": "กรัม",
        //                 "en": "Gram"
        //             },
        //             "marketPrice": 30.5
        //         },
        //         {
        //             "mpID": "6290b30b993dbf3040425b18",
        //             "mpName": {
        //                 "th": "ใบกระเพรา",
        //                 "en": "Holy basil"
        //             },
        //             "pricePerUnit": 20.5,
        //             "quantity": 6,
        //             "actualQuantity": 0,
        //             "total": 123,
        //             "unitName": {
        //                 "th": "กรัม",
        //                 "en": "Gram"
        //             },
        //             "marketPrice": 20.5
        //         },
        //         {
        //             "mpID": "64a2d567e00beb5354406bef",
        //             "mpName": {
        //                 "th": "หมูสับเกรด A",
        //                 "en": "Minced Pork Grade A"
        //             },
        //             "pricePerUnit": 100,
        //             "quantity": 34,
        //             "actualQuantity": 0,
        //             "total": 3400,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 100
        //         },
        //         {
        //             "mpID": "62e4c33a10e6326c7655fd73",
        //             "mpName": {
        //                 "th": "กุนเชียง",
        //                 "en": "Sausage"
        //             },
        //             "pricePerUnit": 150,
        //             "quantity": 4,
        //             "actualQuantity": 0,
        //             "total": 600,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 150
        //         },
        //         {
        //             "mpID": "652aae62c8e9d1410797917a",
        //             "mpName": {
        //                 "th": "มิตรผล น้ำตาลทรายขาวบริสุทธิ์ 1 กิโลกรัม x 5 ถุง",
        //                 "en": "มิตรผล น้ำตาลทรายขาวบริสุทธิ์ 1 กิโลกรัม x 5 ถุง"
        //             },
        //             "pricePerUnit": 66,
        //             "quantity": 56,
        //             "actualQuantity": 0,
        //             "total": 3696,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 66
        //         },
        //         {
        //             "mpID": "6467439211cdf98601eff940",
        //             "mpName": {
        //                 "th": "พริกสวนเด็ด",
        //                 "en": " chili garden"
        //             },
        //             "pricePerUnit": 260,
        //             "quantity": 5,
        //             "actualQuantity": 0,
        //             "total": 1300,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 260
        //         },
        //         {
        //             "mpID": "6467440511cdf98601eff942",
        //             "mpName": {
        //                 "th": "ตะใคร้",
        //                 "en": " lemon grass"
        //             },
        //             "pricePerUnit": 40,
        //             "quantity": 6,
        //             "actualQuantity": 0,
        //             "total": 240,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 40
        //         },
        //         {
        //             "mpID": "62946cc61995110e56339b62",
        //             "mpName": {
        //                 "th": "สะโพกไก่",
        //                 "en": "Chicken thighs"
        //             },
        //             "pricePerUnit": 80,
        //             "quantity": 8,
        //             "actualQuantity": 0,
        //             "total": 640,
        //             "unitName": {
        //                 "th": "กรัม",
        //                 "en": "Gram"
        //             },
        //             "marketPrice": 80
        //         },
        //         {
        //             "mpID": "6467431a11cdf98601eff93d",
        //             "mpName": {
        //                 "th": "กระเพราแดง",
        //                 "en": " red basil"
        //             },
        //             "pricePerUnit": 60,
        //             "quantity": 10,
        //             "actualQuantity": 0,
        //             "total": 600,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 60
        //         },
        //         {
        //             "mpID": "645b6561da746eaf0803b473",
        //             "mpName": {
        //                 "th": "ไข่เป็ด",
        //                 "en": "Duck Egg"
        //             },
        //             "pricePerUnit": 120,
        //             "quantity": 32,
        //             "actualQuantity": 0,
        //             "total": 3840,
        //             "unitName": {
        //                 "th": "แผง",
        //                 "en": "Packs"
        //             },
        //             "marketPrice": 120
        //         },
        //         {
        //             "mpID": "63357b842b6fbde812f8a9ee",
        //             "mpName": {
        //                 "th": "เนื้อ",
        //                 "en": "Meat"
        //             },
        //             "pricePerUnit": 130,
        //             "quantity": 8,
        //             "actualQuantity": 0,
        //             "total": 1040,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 130
        //         },
        //         {
        //             "mpID": "64a2d4bfe00beb5354406bed",
        //             "mpName": {
        //                 "th": "หมูสันคอ",
        //                 "en": "Pork Neck"
        //             },
        //             "pricePerUnit": 128,
        //             "quantity": 23,
        //             "actualQuantity": 0,
        //             "total": 2944,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 128
        //         },
        //         {
        //             "mpID": "646744b511cdf98601eff946",
        //             "mpName": {
        //                 "th": "บล็อกโคลี่",
        //                 "en": "broccoli"
        //             },
        //             "pricePerUnit": 70,
        //             "quantity": 36,
        //             "actualQuantity": 0,
        //             "total": 2520,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 70
        //         },
        //         {
        //             "mpID": "64a2d49de00beb5354406bec",
        //             "mpName": {
        //                 "th": "หมูสามชั้น",
        //                 "en": " Streaky Pork"
        //             },
        //             "pricePerUnit": 145,
        //             "quantity": 5,
        //             "actualQuantity": 0,
        //             "total": 725,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 145
        //         },
        //         {
        //             "mpID": "629b1d3ec3a19dcff457c3d4",
        //             "mpName": {
        //                 "th": "เหล้าจีน",
        //                 "en": "Chinese liquor"
        //             },
        //             "pricePerUnit": 145,
        //             "quantity": 21,
        //             "actualQuantity": 0,
        //             "total": 3045,
        //             "unitName": {
        //                 "th": "กรัม",
        //                 "en": "Gram"
        //             },
        //             "marketPrice": 145
        //         },
        //         {
        //             "mpID": "64a2d51de00beb5354406bee",
        //             "mpName": {
        //                 "th": "มันหมู",
        //                 "en": "Lard"
        //             },
        //             "pricePerUnit": 30,
        //             "quantity": 8,
        //             "actualQuantity": 0,
        //             "total": 240,
        //             "unitName": {
        //                 "th": "กิโลกรัม",
        //                 "en": "Kg."
        //             },
        //             "marketPrice": 30
        //         }

        //   ]
        this.pData.suppDetail[0].contact.phone =
            "08" + this.pData.suppDetail[0].contact.phone.slice(2)
        if (this.pData.list.length < 10) {
            for (let i = this.pData.list.length; i < 10; i++) {
                this.pData.list.push({
                    mpID: "",
                    mpName: {
                        th: "",
                        en: "",
                    },
                    pricePerUnit: "",
                    quantity: "",
                    actualQuantity: "",
                    total: "",
                    unitName: {
                        th: "",
                        en: "",
                    },
                })
            }
        }
        setTimeout(function () {
            var curURL = window.location.href
            // history.replaceState(history.state, '', '');
            window.print()
        }, 500)
        window.onfocus = function () {
            setTimeout(function () {
                window.close()
            }, 100)
        }

        console.log(this.pData)
        this.messageService.sendMessage("print")
    }
}
